(() => {
  'use strict';

  const $ = (selector, context = document) => context.querySelector(selector);
  const $$ = (selector, context = document) => Array.from(context.querySelectorAll(selector));

  const gallery = $('[data-np-gallery]');
  if (gallery) {
    const thumbs = $$('[data-gallery-thumb]', gallery);
    const slides = $$('[data-gallery-slide]', gallery);
    const counter = $('[data-gallery-current]', gallery);
    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));

    const activate = (index, focusThumb = false) => {
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (!active) slide.querySelectorAll('video').forEach((video) => video.pause());
      });
      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === activeIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (counter) counter.textContent = String(activeIndex + 1);
      if (focusThumb) thumbs[activeIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => activate(index)));
    $('[data-gallery-prev]', gallery)?.addEventListener('click', () => activate(activeIndex - 1, true));
    $('[data-gallery-next]', gallery)?.addEventListener('click', () => activate(activeIndex + 1, true));

    let touchStartX = 0;
    const stage = $('.np-gallery__stage', gallery);
    stage?.addEventListener('touchstart', (event) => { touchStartX = event.touches[0].clientX; }, { passive: true });
    stage?.addEventListener('touchend', (event) => {
      const distance = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(distance) < 45) return;
      activate(distance < 0 ? activeIndex + 1 : activeIndex - 1, true);
    }, { passive: true });

    const productSection = $('[data-product-section]');
    const variantsJson = $('[data-product-variants]', productSection || document);
    if (productSection && variantsJson) {
      let variants = [];
      try { variants = JSON.parse(variantsJson.textContent); } catch (_) { variants = []; }
      const optionInputs = $$('input[type="radio"][name^="options"]', productSection);
      const updateVariantMedia = () => {
        const selected = $$('fieldset', productSection).map((fieldset) => $('input:checked', fieldset)?.value);
        const variant = variants.find((entry) => entry.options?.every((option, index) => option === selected[index]));
        const mediaId = variant?.featured_media?.id || variant?.featured_image?.id;
        if (!mediaId) return;
        const index = slides.findIndex((slide) => String(slide.dataset.gallerySlide) === String(mediaId));
        if (index >= 0) activate(index, true);
      };
      optionInputs.forEach((input) => input.addEventListener('change', updateVariantMedia));
    }
  }


  const sticky = $('[data-sticky-buy]');
  const productMain = $('[data-product-section]');

  if (sticky && productMain) {
    const mainForm = $('[data-product-form]', productMain);
    const mainAdd = $('.product-add', productMain);
    const stickyAdd = $('[data-sticky-add]', sticky);
    const stickyLabel = $('[data-sticky-add-label]', sticky);
    const mainLabel = $('[data-add-label]', productMain);
    let ticking = false;

    const syncStickyButton = () => {
      if (!stickyAdd || !mainAdd) return;
      stickyAdd.disabled = mainAdd.disabled;
      if (stickyLabel && mainLabel) stickyLabel.textContent = mainLabel.textContent.trim();
      stickyAdd.setAttribute(
        'aria-label',
        mainAdd.disabled ? 'Rupture de stock' : 'Ajouter au panier'
      );
    };

    const updateSticky = () => {
      const addRect = mainAdd?.getBoundingClientRect();
      const footer = document.querySelector('.lume-footer, footer');
      const footerRect = footer?.getBoundingClientRect();
      const passedMainAction = Boolean(
        addRect &&
        addRect.bottom < (window.innerWidth >= 990 ? 96 : 0) &&
        window.scrollY > 160
      );
      const footerIsVisible = Boolean(
        footerRect && footerRect.top < window.innerHeight - 12
      );
      const shouldShow = passedMainAction && !footerIsVisible;

      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateSticky);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });

    stickyAdd?.addEventListener('click', () => {
      if (!mainForm || !mainAdd || mainAdd.disabled) return;
      mainForm.requestSubmit(mainAdd);
    });

    if (mainAdd) {
      new MutationObserver(syncStickyButton).observe(mainAdd, {
        attributes: true,
        attributeFilter: ['disabled']
      });
    }

    document.addEventListener('variant:change', syncStickyButton);
    syncStickyButton();
    updateSticky();
  }



  const instagramTrack = $('[data-instagram-track]');
  if (instagramTrack && window.matchMedia('(max-width: 989px)').matches) {
    requestAnimationFrame(() => {
      const posts = $$('.np-instagram__post', instagramTrack);
      const middle = posts[Math.floor(posts.length / 2)];
      if (middle) {
        const left = middle.offsetLeft - (instagramTrack.clientWidth - middle.clientWidth) / 2;
        instagramTrack.scrollTo({ left, behavior: 'auto' });
      }
    });
  }


})();
